import { Stack } from '@repletoryreach/sdk-ui';
import { ForgotForm } from './components/ForgotForm';
import { AuthCardHeader } from '../components/AuthCardHeader';
import { useT } from '../../../i18n/I18nProvider';

export default function ForgotPasswordPage() {
  const t = useT();
  return (
    <Stack gap="md">
      <AuthCardHeader title={t('auth.forgot.title')} subtitle={t('auth.forgot.hint')} />
      <ForgotForm />
    </Stack>
  );
}
